<ul>
  <li *ngFor="let reason of data">
    {{reason}}
  </li>
</ul>
